import { FormattedMessage } from 'react-intl';

import messagesDE from './PersonalInformationDE.messages';
import FormField from '../../components/FormField';
import { FieldWrapper } from '../PersonalInformation/types/PersonalInformation.types';

export const StreetLineOneQuestion = ({
    field
}: {
    field: FieldWrapper<string>;
}) => {
    const renderLabel = () => {
        return <FormattedMessage {...messagesDE.firstAddressLine} />;
    };

    const renderSubText = () => {
        return (
            <FormattedMessage {...messagesDE.streetLineOneQuestionSubtext} />
        );
    };

    const label = renderLabel();
    const subText = renderSubText();

    return (
        <FormField
            wrapperClassName="fs-exclude"
            field={field}
            label={label}
            subText={subText}>
            <FormField.Input className="xs-push" maxLength={250} />
        </FormField>
    );
};

export default StreetLineOneQuestion;
